import {isPhone, vs} from '@/Utils/Dimensions';
import CCColors, {updateColorWithOpacity} from '../../../../Utils/CCColors';
import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    backgroundColor: CCColors?.White,
    padding: isPhone ? 0 : 20,
    justifyContent: isPhone ? 'flex-start' : 'center',
    borderRadius: 10,
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15,
    color: CCColors?.TextColor?.Primary,
    textAlign: 'center',
    flex: 1,
  },
  input: {
    width: '100%',
    height: isPhone ? 100 : 130,
    borderColor: CCColors?.Border,
    borderWidth: 1,
    borderRadius: 5,
    padding: 10,
    marginBottom: 15,
    fontSize: 16,
    textAlignVertical: 'top',
  },
  uploadFiles: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: CCColors?.Primary?.lightBrown,
    paddingVertical: 10,
    paddingHorizontal: 15,
    marginBottom: 15,
    width: '100%',
    borderRadius: 8,
    border: '1px dashed rgba(34, 34, 34, 0.20)',
    height: 150,
    display: 'flex',
    cursor: 'pointer',
  },
  uploadText: {
    textAlign: 'center',
    color: CCColors?.TextColor?.Primary,
    fontSize: 16,
    marginRight: 10,
  },
  deleteWrapper: {
    position: 'absolute',
    right: 10,
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: updateColorWithOpacity(
      CCColors?.WrongMoves?.Background,
      0.16,
    ),
    justifyContent: 'center',
    alignItems: 'center',
  },
  deleteIcon: {
    color: CCColors?.WrongMoves?.Background,
  },
  button: {
    width: '100%',
    alignSelf: 'center',
  },
  successContainer: {
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  successIcon: {
    marginBottom: 10,
  },
  successText: {
    textAlign: 'center',
    color: CCColors?.TextColor?.Primary,
    fontSize: 18,
    marginRight: 10,
    maxWidth: '90%',
    width: isPhone ? '100%' : '75%',
    flexWrap: 'wrap',
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 10,
  },
  infoBox: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: CCColors?.Grey?.Border,
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: vs(8),
    minWidth: 130,
  },
  verticalLine: {
    width: 1,
    height: '100%',
    backgroundColor: CCColors?.Grey?.Border,
    marginHorizontal: 8,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 12,
  },
  viewTicketBtn: {
    borderRadius: 30,
  },
  okayBtn: {
    backgroundColor: CCColors?.Primary?.lightBrown,
    borderRadius: 30,
  },
  attachmentContainer: {
    width: '100%',
    marginBottom: isPhone ? 10 : 20,
  },
  labelRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  inputWrapper: {
    width: '100%',
    height: 58,
    borderColor: CCColors?.Border,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 10,
  },
  inputField: {
    flex: 1,
    fontSize: 14,
    borderColor: 'none',
  },
  browseText: {
    fontSize: 14,
    fontWeight: '500',
  },
  uploadPreview: {
    marginTop: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  fileName: {
    flex: 1,
    fontSize: 14,
    marginLeft: 10,
  },
  inputLabelStyle: {
    fontSize: 16,
    marginBottom: 6,
    marginTop: isPhone ? 10 : 20,
  },
});

export default styles;
